/**
 * HOR-92 (Review ADM-4 / F1): Deep Links wie /services?open=123 ueberleben den Login.
 *
 * Ohne gueltige Session ersetzte main.jsx die Ziel-URL durch /login, und die Login-Seite
 * sprang danach fest nach /services – der open-Parameter aus der Benachrichtigungs-Mail war
 * weg und das Modal blieb zu. Deshalb wandert das urspruengliche Ziel als ?redirect=<pfad+query>
 * an /login und wird nach erfolgreichem Login wieder angesteuert.
 *
 * Sicherheit (kein Open Redirect): akzeptiert werden ausschliesslich relative Pfade derselben
 * Origin – "//evil.example", "/\evil.example" oder absolute URLs werden verworfen. /login selbst,
 * die Startseite und das ohnehin voreingestellte /services sind kein sinnvolles Ziel und fallen
 * auf den Default zurueck, damit die Login-URL sauber bleibt.
 */
export const DEFAULT_AFTER_LOGIN = '/services'

export const sanitizeRedirectTarget = value => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null

  let url

  try {
    url = new URL(value, window.location.origin)
  } catch (e) {
    return null
  }

  if (url.origin !== window.location.origin) return null

  const target = `${url.pathname}${url.search}${url.hash}`

  if (target === '/' || target === DEFAULT_AFTER_LOGIN || target === '/login' || target.startsWith('/login?') || target.startsWith('/login/')) return null

  return target
}

/** Login-URL mit optionalem Grund (?reason=) und gemerktem Ziel (?redirect=). */
export const loginUrl = ({ reason, redirect } = {}) => {
  const params = new URLSearchParams()

  if (reason) params.set('reason', reason)

  const target = sanitizeRedirectTarget(redirect)

  if (target) params.set('redirect', target)

  const query = params.toString()

  return query ? `/login?${query}` : '/login'
}

/** Aktuelle Browser-Adresse (Pfad + Query + Hash) als Redirect-Kandidat. */
export const currentLocationTarget = () => `${window.location.pathname}${window.location.search}${window.location.hash}`

/** Ziel nach erfolgreichem Login aus der Login-Query (?redirect=), sonst /services. */
export const afterLoginTarget = search => sanitizeRedirectTarget(new URLSearchParams(search || '').get('redirect')) || DEFAULT_AFTER_LOGIN
